/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner } from './bulk-disable-daily-user-usage-limit200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableDailyUserUsageLimit200ResponseInnerReissue } from './bulk-disable-daily-user-usage-limit200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableDailyUserUsageLimit200ResponseInnerUser } from './bulk-disable-daily-user-usage-limit200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup } from './bulk-disable-daily-user-usage-limit200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface BulkDisableDailyUserUsageLimit200ResponseInner
 */
export interface BulkDisableDailyUserUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkDisableDailyUserUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimit200ResponseInnerUser}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'user': BulkDisableDailyUserUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkDisableDailyUserUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {BulkDisableDailyUserUsageLimit200ResponseInnerReissue}
     * @memberof BulkDisableDailyUserUsageLimit200ResponseInner
     */
    'reissue'?: BulkDisableDailyUserUsageLimit200ResponseInnerReissue | null;
}

export const BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkDisableDailyUserUsageLimit200ResponseInnerAvailableCurrenciesEnum];


